<template>
    <transition enter-active-class="animated fadeIn">
        <div class="templateDesigner group p-20">
            <div :class="{ 'm-b-20': ($store.state.mode === 'designer')}" class="design-options p-10 p-b-0 primarybg">
                <a @click="$router.go(-1)" class="btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg left" v-if="$store.state.mode === 'designer' && $store.state.templateList !== null"><span class="icon-angle-left m-r-5 primarytext"></span> Back to Templates</a>
                <a @click="$router.push('/templates/vendor')" class="btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg left" v-else-if="$store.state.mode === 'designer' && $store.state.template !== null && $store.state.template.vendors && $store.state.template.vendors.data.length > 0"><span class="icon-angle-left m-r-5 primarytext"></span> Back to Templates</a>

                <!-- ## Template File Side Buttons ## -->
                <button type="button" :class="checkActive(button)" class="btn btn-outline-primary m-b-10 m-r-5 primaryborder left" @click="switchTemplate(button)" v-for="(button, index) in this.buttons" :key="index">{{ button }}</button>

                <!-- ## Template File Side Buttons ## -->
                <button v-if="this.$store.state.mode === 'editor'" type="button" @click="saveTemplate()" :class="{'animated pulse orange solid': (templateChanges())}" class="btn btn-outline-success m-b-10 right primaryborder m-r-5">
                        {{ (templateChanges()) ? saveStatus : 'Saved '}}
                        <span v-if="templateChanges()" class="icon-save m-l-5"></span>
                        <span v-else class="icon-checkmark-circle m-l-5"></span>
                </button>

                <div class="btn-group m-b-10 right" v-if="$store.state.mode === 'designer'">
                    <button type="button" class="btn btn-outline-success primaryborder dropdown-toggle waves-effect waves-light" data-toggle="dropdown" aria-expanded="false">Zoom: {{ zoom * 100 + '%' }} <span class="icon-arrow-down"></span></button>
                    <ul class="dropdown-menu" role="menu">
                        <li><a href="#" v-on:click.prevent="resizeCanvas(1)">100%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.9)">90%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.8)">80%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.7)">70%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.6)">60%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.5)">50%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.4)">40%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.3)">30%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.2)">20%</a></li>
                        <li><a href="#" v-on:click.prevent="resizeCanvas(.1)">10%</a></li>
                    </ul>
                </div>

                <span v-if="$store.state.mode === 'designer' && $store.state.config.hideDeepLinks !== true" class="btn btn-outline-primary waves-effect waves-light right m-r-5" @click.prevent="copyUrl"><span class="icon-link"></span></span>

            </div>

            <div class="canvasEditors">
                <PrimoCanvas v-if="$store.state.template" ref="primoCanvas" :prod-height="($store.state.template) ? $store.state.template.height : 0" :prod-width="($store.state.template) ? $store.state.template.width : 0" :prod-safe="($store.state.template.safe)" :prod-bleed="($store.state.template.bleed)" :display-type="this.$store.state.mode"></PrimoCanvas>
            </div>
        </div>
    </transition>
</template>

<script>
/* global Helpers */

import PrimoCanvas from './partials/Canvas.vue'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import { windowMessaging } from '@/components/mixins/windowMessaging'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
    name: 'templateDesigner',
    components: {PrimoCanvas, HalfCircleSpinner},
    mixins: [windowMessaging],
    data () {
        return {
            msg: 'Template Designer',
            saveStatus: 'Save Design',
            zoom: 1,
            showUrlCopy: false
        }
    },
    beforeMount () {
        this.axios.get('/templates/' + this.$route.params.uuid + '?include=userversions,productsettings,vendors')
        .then(
            response => {
                let template = response.data.data

                Object.keys(template.files).forEach((key) => {
                    template.files[key].confirmed = false
                })

                this.$store.commit('template', response.data.data)
            }
        ).catch(function (error) {
            Helpers.errorPop('Error', error)
        })
    },
    computed: {
        url () {
            let url = this.$store.state.pageUrl
            let queryString = '?'
            if (this.$route.params.uuid) {
                queryString += 'template=' + this.$route.params.uuid
            }
            if (queryString === '?') {
                queryString = ''
            }
            return url + queryString
        },
        buttons () {
            let nav = []

            if (this.$store.state.template) {
                Object.keys(this.$store.state.template.files).forEach(function (key) {
                    nav.push(key.replace(new RegExp('_', 'g'), ' ').replace(/\b\w/g, l => l.toUpperCase()).replace('Uv', 'UV'))
                })
            }

            return nav
        },
        templateState () {
            return this.$store.state.templateChanges
        }
    },
    watch: {
        templateState: function (newState, oldState) {
            this.windowMsgTemplateStatus({'changes': newState})
        }
    },
    methods: {
        saveTemplate () {
            if (this.templateChanges()) {
                this.saveStatus = 'Saving, Please Wait..'
                this.$refs.primoCanvas.exportData()
                this.$refs.primoCanvas.generateImage()

                let parnt = this
                let templateId = this.$store.state.template.id

                let template = this.$store.state.template
                let files = template.files
                let activeFonts = []
                Object.keys(files).forEach(function (key) {
                    let fonts = []
                    if (files[key].json !== null) {
                        for (var i in files[key].json.objects) {
                            if (files[key].json.objects[i].fontFamily !== undefined && files[key].json.objects[i].fontFamily !== null && files[key].json.objects[i].fontFamily !== '') {
                                fonts.push(files[key].json.objects[i].fontFamily)
                                activeFonts.push(files[key].json.objects[i].fontFamily)
                            }
                        }
                    }
                    files[key].fonts = fonts
                })
                template.files = files
                this.$store.commit('template', template)
                this.$store.commit('activeFonts', activeFonts)

                let data = {
                    files: JSON.stringify(files)
                }

                this.axios.put('/templates/' + templateId, data)
                .then(function (res) {
                    parnt.saveStatus = 'Save Design'
                    parnt.$store.commit('templateChanges', false)

                    parnt.windowMsgTemplateUpdate(res.data.data.files)
                })
                .catch(function (err) {
                    Helpers.errorPop('Error', err)
                })
            }
        },
        switchTemplate (e) {
            this.$store.commit('activeTemplate', e.toLowerCase().replace(new RegExp(' ', 'g'), '_'))
        },
        templateChanges () {
            return this.$store.state.templateChanges
        },
        checkActive (e) {
            if (e.toLowerCase().replace(new RegExp(' ', 'g'), '_') === this.$store.state.activeTemplate) {
                return ''
            } else {
                return 'notactive primaryaltbg'
            }
        },
        resizeCanvas (zoom) {
            this.zoom = zoom
            this.$refs.primoCanvas.resizeCanvas(zoom)
        },
        copyUrl () {
            this.$copyText(this.url).then((e) => {
                swal({
                    type: 'success',
                    title: 'Link Copied!',
                    animation: true,
                    position: 'top'
                })
            }, (e) => {
                alert('Can not copy')
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .canvasEditors{
        position: relative;
    }
    .orange{
        background: #f4941f;
    }
</style>



// WEBPACK FOOTER //
// TemplateDesigner.vue?541becc6